import CustomSlider from './Slider'
import CustomSwitch from './Switch'
import { useAppContext } from 'context'
import { saveTimeVariation } from 'lib/api/capital'
import { toast } from 'sonner'

export default function TimeToComplete({
  setIsLoadingRoi,
  setIsLoadingSchedule,
  next,
  checked,
  onChange,
}) {
  const { developer } = useAppContext()

  const handleChange = async (value) => {
    try {
      setIsLoadingSchedule(true)
      setIsLoadingRoi(true)
      const response = await saveTimeVariation({
        developerName: developer.split(' ')?.[0],
        payload: {
          value_change: Math.abs(value / 100),
          status: value < 0 ? 'decrement' : 'increment',
        },
      })
      next({
        scheduleData: response.payload.schedule_feasibility,
        roiData: response.payload.annualized_roi,
      })
    } catch (error) {
      toast.error(error.message ?? 'An error occurred while saving cost variation')
    } finally {
      setIsLoadingSchedule(false)
      setIsLoadingRoi(false)
    }
  }

  return (
    <section>
      <div className="grid grid-cols-[90px_auto_auto]  items-center">
        <p className="graph-title text-02 font-semibold  text-xs font-libre">Time to complete</p>
        <CustomSlider disabled={checked === false} handleChange={(value) => handleChange(value)} />
        <CustomSwitch checked={checked} onChange={onChange} />
      </div>
    </section>
  )
}
